import { DeviceInfo } from 'qunar-react-native';

const { scheme } = DeviceInfo;
const schemaRule = /qunar(\w*)[ia]phone(\w*)/i;
const navigate = (
    params: { url?: string; schema: string; isSchema: boolean; type?: string },
    callback?: any
) => {
    const { url, schema, isSchema, type = 'navibar-normal' } = params;
    let completeUrl;
    if (isSchema) {
        completeUrl = schemaRule.test(schema) ? schema : `${scheme}://${schema}`;
    } else {
        completeUrl = `${scheme}://hy?url=${encodeURIComponent(url)}&type=${type}`;
    }
    Ext.Router.Bridge.sendScheme(
        {
            url: completeUrl
        },
        (res) => {
            return callback?.(res);
        }
    );
};

// global.$navigate = navigate;

// export default navigate;
export { navigate };
